import { useEffect, useRef, useState } from "react";
import { history } from "../../history";
import { LOCATION_STATE_KEY } from "../../store/formStates/config";
import { Path } from "../../store/formStates/utilities";
import { FORM_RECOVER_DELAY } from "./config";

const defaultCondition = () => true;

export const useRecoverForm = (recoverFn, condition = defaultCondition) => {
  const recovered = useRef(false);
  const timeout = useRef(null);
  const [isRecovering, setIsRecovering] = useState(false);

  useEffect(() => {
    const state = history.location?.state?.[LOCATION_STATE_KEY];
    if (
      state?.path === Path.create() &&
      !recovered.current &&
      condition() &&
      !isRecovering
    ) {
      setIsRecovering(true);
      timeout.current = setTimeout(() => {
        recoverFn(state.data);
        recovered.current = true;
        const { [LOCATION_STATE_KEY]: _, ...rest } = history.location.state;
        history.replace({ ...history.location, state: rest });
        setIsRecovering(false);
      }, FORM_RECOVER_DELAY);
    }
  }, [
    history.location?.state?.[LOCATION_STATE_KEY],
    Path.create(),
    condition(),
    isRecovering,
    recoverFn,
  ]);

  useEffect(() => {
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);

  return {
    isRecovered: recovered.current,
  };
};
